<template>
  <!--成品管理-->
  <div>
    <s-pageheader title="成品配方" />
    <ak-model-filter-card model="parts" @search="search" @reset="reset" :perPage="30" />
    <!--成品-->
    <ak-model-tree
      :treeSpan="4"
      model="finishProduct"
      treeModel="finishWorkShop"
      parentKey="parentNode"
      pointerToTree="proportion"
      treeTitle="车间检索"
      :multiple="false"
      :defaultSelected="key"
      :autoExpandParent="true"
      @selected="getTree"
      :action="edit"
      :modelTableProps="modelTableProps"
    />
  </div>
</template>

<script>
import editProduct from '@/core/components/editProduct'
import PageHeader from '@/components/PageHeader/PageHeader'
import editFinishProduct from '@/core/components/editFinishProduct'
import check from '@/core/components/check'
import { mapState } from 'vuex'
import store from '@/store'
export default {
  components: {
    's-pageheader': PageHeader
  },
  data () {
    return {
      edit: {
        // 覆盖model的action
        create: {},
        edit: false,
        check: {}
      },
      modelTableProps: {
        perPage: 30,
        page: 1,
        filters: {}
      },
      key: '' // 默认选中的节点ID
    }
  },
  computed: {
    ...mapState(['user'])
  },
  created () {
    // if (store.state.user.adminRole === 'admin' || (store.state.user.adminRole === 'workshop' && store.state.user.operate === 'yes')) {
    let key = store.state.finishProductKey
    if (key !== '') {
      if (key.model) {
        if (key.proportion) {
          this.key = key.proportion
        } else {
          this.key = key.model
        }
      } else {
        this.key = key.workShop
      }
    }
    console.log('kkkkkey', this.key)
    // this.modelTableProps.filters = {}
    if (store.state.user && store.state.user.authority.finishProduct.edit) {
      this.edit.edit = {
        type: 'row', // 指单行按钮，显示在表格单行数据的右侧
        text: '编辑',
        component: editProduct
      }
      this.edit.check = false
    } else {
      this.edit.edit = false
      this.edit.check = {
        type: 'row',
        text: '查看',
        component: check
      }
    }
  },
  mounted () { },
  methods: {
    search (filters) {
      this.$set(this.modelTableProps, 'filters', filters)
      this.$set(this.modelTableProps, 'page', 1)
      console.log('filters', this.filters)
    },
    reset () {
      this.$set(this.modelTableProps, 'filters', {})
      this.$set(this.modelTableProps, 'page', 1)
    },
    // 监听树节点选中状态
    getTree (obj) {
      let data = { workShop: '', model: '', proportion: '' }
      if (obj.length > 0 && obj[0] !== undefined) {
        if (obj[0].parentNode) {
          if (obj[0].parentNode.parentNode) {
            data.workShop = obj[0].parentNode.parentNode.key
            data.model = obj[0].parentNode.key
            data.proportion = obj[0].key
          } else {
            data.workShop = obj[0].parentNode.key
            data.model = obj[0].key
          }
        } else {
          data.workShop = obj[0].key
        }
        store.commit('setFinishProductKey', data)
      } else {
        store.commit('setFinishProductKey', '')
      }
      // 根据选中的节点判断新建按钮是否显示
      // if (this.user.adminRole) {
      // }
      // if (store.state.user.adminRole === 'workshop' && store.state.user.operate !== 'no') { }
      // if (
      //   obj.length === 1 &&
      //   obj[0] !== undefined &&
      //   obj[0].record.type === 'ratio' &&
      //   store.state.user.adminRole !== 'workshop' &&
      //   store.state.user.adminRole !== 'sale'
      // )
      if (
        obj.length === 1 &&
        obj[0] !== undefined &&
        obj[0].record.type === 'ratio' &&
        store.state.user && store.state.user.authority.finishProduct.create
      ) {
        this.edit.create = {
          text: '新建',
          title: '添加成品',
          type: 'list',
          icon: 'plus',
          buttonType: 'primary', // 按钮的类型
          proportion: obj[0].key,
          modelId: obj[0].parentNode.key,
          workShop: obj[0].record.workShop.objectId,
          component: editFinishProduct
        }
      } else { this.edit.create = false }
      // if (store.state.user && store.state.user.authority.finishProduct.create) {
      //   this.edit.create = {
      //     text: '添加成品',
      //     type: 'list',
      //     buttonType: 'primary', // 按钮的类型
      //     proportion: obj[0].key,
      //     modelId: obj[0].parentNode.key,
      //     workShop: obj[0].record.workShop.objectId,
      //     component: editFinishProduct
      //   }
      // } else {
      //   this.edit.create = false
      // }
      // }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .node-icon:before {
  content: none !important;
}
</style>
